import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import italia from '../vendor/italia'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeUserCreateScreen from '../screens/BackOfficeUserCreateScreen'
import {actions as addressActions} from '../redux/modules/Address'
import {actions as areaActions} from '../redux/modules/Area'

const mapStateToProps = (state) => {
  return {
    state: state.users,
    addresses: state.address
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addressActions: bindActionCreators(addressActions, dispatch)
  }
}

const ITALIA_COMUNI = italia.comuni.map(item => {
  const label = item.comune + ' (' + item.provincia + ')'
  return {
    label: label,
    value: label
  }
})

const ITALIA_COMUNI_SENZA_LODI_E_ESTERO = ITALIA_COMUNI.slice(2, ITALIA_COMUNI.length)
const ITALIA_COMUNI_SENZA_ESTERO = ITALIA_COMUNI.slice(1, ITALIA_COMUNI.length)

const randomPassword = (length = 5) => {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let text = ''

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

class BackOfficeUserCreateContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      userTypes: [],
      categories: [],
      userCreateResult: {},
      areas: [],
      selectedCategories: [],
      selectedArea: null,
      selectedParkingSpaceArea: null,
      searchingFiscalCodeInitialized: false,
      currentFiscalCode: null,
      searchingFiscalCode: false,
      foundFiscalCode: null,
      selectedParkingSpaces: []
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onCategoriesChange = this.onCategoriesChange.bind(this)
    this.onAddressSelected = this.onAddressSelected.bind(this)
    this.onParkingSpaceAddressSelected = this.onParkingSpaceAddressSelected.bind(this)
    this.onFiscalCodeChange = this.onFiscalCodeChange.bind(this)
    this.onSearchFiscalCodeAndFormFilling = this.onSearchFiscalCodeAndFormFilling.bind(this)
    this.onAddParkingSpace = this.onAddParkingSpace.bind(this)
    this.onRemoveParkSpace = this.onRemoveParkSpace.bind(this)
    this.onMultipleParkingSpaceAddressSelected = this.onMultipleParkingSpaceAddressSelected.bind(this)
  }

  mapCategories (items) {
    return items.map(item => {
      let children = null
      if (item.Children.length > 0) {
        children = this.mapCategories(item.Children)
      }

      return {
        value: item.id,
        label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        children: children,
        resident: item.resident,
        worker: item.worker,
        workerPerson: item.workerPerson,
        parkingInDifferentPlace: item.parkingInDifferentPlace,
        multipleParkingSpace: item.multipleParkingSpace
      }
    })
  }

  componentWillMount () {
    // this.fetchUserTypes();
    this.fetchUserCategories()
    this.fetchAreas()
    this.props.addressActions.fetchAddresses()
  }

  fetchUserTypes () {
    SostaOnlineApiService.fetchUserTypes().then((data) => {
      this.setState({userTypes: data.data})
    })
  }

  fetchAreas () {
    SostaOnlineApiService.fetchAreas().then(data => {
      this.setState({areas: data.data})
    })
  }

  fetchUserCategories () {
    SostaOnlineApiService.fetchUserCategories().then((data) => {
      this.setState({categories: this.mapCategories(data.data)})
    })
  }

  getAddressById (addressId) {
    let address = this.props.addresses.data.filter(item => item.id === addressId)
    return address[0]
  }

  onSubmit (data) {
    this.setState({loading: true, error: null, userCreateSuccess: false, userCreateError: false})
    let password = randomPassword(8)

    // let isResident = data.userCategories.map(item => )
    const userCategories = this.state.selectedCategories.map(item => item.value)
    const userParkSpaceAddresses = this.state.selectedParkingSpaces.map((item, index) => {
      return data['parkingSpaceAddress' + index]
    })

    console.log(data)
    let obj = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      fiscalCode: data.fiscalCode,
      password: password,

      sex: data.sex,
      birthDate: data.birthDate,
      birthPlace: data.birthPlace,

      companyName: data.companyName,
      workAddress: data.workAddress,
      companyLegalAddress: data.workAddress,
      workCity: data.workCity,
      workCap: data.workCap,
      vatNumber: data.vatNumber,
      userCategories: userCategories,

      secondaryResidenceCity: data.secondaryResidenceCity,
      secondaryResidenceAddress: data.secondaryResidenceAddress,
      secondaryResidenceCap: data.secondaryResidenceCap,

      parkSpaceAddress: data.parkingSpaceAddress,
      parkSpaceAddresses: userParkSpaceAddresses
    }

    if (this.state.selectedCategories[0].resident) {
      obj['residenceCity'] = 'Empoli'
      obj['residenceCap'] = 20016
      obj['residenceAreaId'] = this.state.selectedArea.id
      obj['residenceAddress'] = this.getAddressById(typeof data.residenceAddress === 'object' ? data.residenceAddress.value : data.residenceAddress).name
      obj['residenceCivicNumber'] = data.residenceCivicNumber
    }
    if (this.state.selectedCategories[0].workerPerson) {
      obj['workAddress'] = data.workAddress
      // obj['workAreaId'] = this.state.selectedArea.id
      // obj['workAddress'] = this.getAddressById(typeof data.residenceAddress === 'object' ? data.workAddress.value : data.workAddress).name
    }

    console.log(obj)

    SostaOnlineApiService.createUser(obj).then(result => {
      this.setState({
        error: null,
        loading: false,
        userCreateSuccess: true,
        userCreateError: false,
        userCreateResult: result
      })
    }).catch(err => {
      console.log(err)
      this.setState({
        error: 'Errore nella creazione utente',
        userCreateResult: err,
        loading: false,
        userCreateSuccess: false,
        userCreateError: true
      })
    })
  }

  onCategoriesChange (selectedNodes) {
    this.setState({
      selectedCategories: selectedNodes.map(item => ({
        label: item.label,
        value: item.value,
        resident: item.resident,
        worker: item.worker,
        workerPerson: item.workerPerson,
        parkingInDifferentPlace: item.parkingInDifferentPlace,
        multipleParkingSpace: item.multipleParkingSpace
      }))
    })
  }

  onAddressSelected (addressId) {
    if (!addressId) {
      this.setState({selectedArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({selectedArea: address[0].Area})
  }

  onParkingSpaceAddressSelected (addressId) {
    if (!addressId) {
      this.setState({selectedParkingSpaceArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({selectedParkingSpaceArea: address[0].Area})
  }

  onMultipleParkingSpaceAddressSelected (addressId, index) {
    const {selectedParkingSpaces} = this.state
    if (!addressId) {
      this.setState({selectedParkingSpaceArea: null})
      return
    }

    let address = this.props.addresses.data.filter(item => {
      return item.id === addressId
    })
    this.setState({selectedParkingSpaces: selectedParkingSpaces.map((item, i) => {
      if (i === index) {
        return ({
          ...item,
          area: address[0].Area
        })
      } else {
        return item
      }
    })})
  }

  onFiscalCodeChange (e) {
    this.setState({
      currentFiscalCode: e.target.value
    })
  }

  async onSearchFiscalCodeAndFormFilling () {
    this.setState({
      foundFiscalCode: null,
      searchingFiscalCode: true,
      searchingFiscalCodeInitialized: true
    })
    let result
    try {
      result = await SostaOnlineApiService.fetchMerge(this.state.currentFiscalCode)
    } catch (err) {
      console.log(err)
      this.setState({
        searchingFiscalCode: false,
        foundFiscalCode: null
      })
      return
    }
    this.setState({
      searchingFiscalCode: false,
      foundFiscalCode: result.data
    }, () => {
      console.log(result.data)
      if (result.data !== null && result.data.category !== null) {
        this.onCategoriesChange([{
          label: result.data.category.label,
          resident: result.data.category.resident,
          worker: result.data.category.worker,
          parkingInDifferentPlace: result.data.category.parkingInDifferentPlace,
          value: result.data.category.id
        }])
        if (result.data.adjustmentUser !== null) {
          const addressesFound = this.props.addresses.data
            .filter(item => item.name === result.data.adjustmentUser.residenceAddress)
          if (addressesFound.length > 0) {
            return this.onAddressSelected(addressesFound[0].id)
          }
        }
        if (result.data.mergeUser !== null) {
          const addressesFound = this.props.addresses.data
            .filter(item => item.name === result.data.mergeUser.residenceAddress)
          if (addressesFound.length > 0) {
            return this.onAddressSelected(addressesFound[0].id)
          }
        }
      }
    })
  }

  onAddParkingSpace () {
    const {selectedParkingSpaces} = this.state
    this.setState({selectedParkingSpaces: [...selectedParkingSpaces, {}]})
  }
  onRemoveParkSpace (index) {
    const {selectedParkingSpaces} = this.state
    this.setState({
      selectedParkingSpaces: selectedParkingSpaces.filter((item, i) => i !== index)
    })
  }

  render () {
    const {foundFiscalCode} = this.state
    let residenceAddressValue
    if (foundFiscalCode && this.props.addresses) {
      let addressesFound
      if (foundFiscalCode.adjustmentUser !== null) {
        addressesFound = this.props.addresses.data
          .filter(item => item.name === foundFiscalCode.adjustmentUser.residenceAddress)
          .map(item => ({label: item.name, value: item.id}))
      } else if (foundFiscalCode.mergeUser !== null) {
        addressesFound = this.props.addresses.data
          .filter(item => item.name === foundFiscalCode.mergeUser.residenceAddress)
          .map(item => ({label: item.name, value: item.id}))
      }
      console.log(addressesFound)
      if (addressesFound !== undefined && addressesFound.length > 0) {
        residenceAddressValue = addressesFound[0]
      }
    }
    let user
    if (foundFiscalCode !== null && foundFiscalCode.adjustmentUser !== null) {
      user = foundFiscalCode.adjustmentUser
    } else if (foundFiscalCode !== null && foundFiscalCode.mergeUser !== null) {
      user = foundFiscalCode.mergeUser
    }
    return (
      <BackOfficeUserCreateScreen
        initialValues={user ? {
          cid: foundFiscalCode.CategoryId,
          fiscalCode: user.fiscalCode,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
          birthDate: user.birthDate,
          birthPlace: user.birthPlace,
          residenceAddress: residenceAddressValue,
          residenceCap: user.residenceCap,
          residenceCity: user.residenceCity,
          residenceCivicNumber: user.residenceCivicNumber,
          secondaryResidenceCity: user.secondResidenceCity,
          secondaryResidenceCap: user.secondResidenceCap,
          secondaryResidenceAddress: user.secondResidenceAddress,
          sex: user.sex,
          userCategories: (foundFiscalCode.category !== null) ? [{
            label: foundFiscalCode.category.label,
            resident: foundFiscalCode.category.resident,
            worker: foundFiscalCode.category.worker,
            parkingInDifferentPlace: foundFiscalCode.category.parkingInDifferentPlace,
            value: foundFiscalCode.category.value
          }] : null
        } : null}
        areas={this.state.areas}
        addresses={this.props.addresses}
        categoryOptions={this.state.categories}
        loading={this.state.loading}
        userCreateError={this.state.error}
        userCreateSuccess={this.state.userCreateSuccess}
        userCreateResult={this.state.userCreateResult}
        selectedParkingSpaceArea={this.state.selectedParkingSpaceArea}
        onCategoriesChange={this.onCategoriesChange}
        selectedCategories={this.state.selectedCategories}
        comuni={ITALIA_COMUNI}
        comuniWithoutLodi={ITALIA_COMUNI_SENZA_ESTERO}
        selectedArea={this.state.selectedArea}
        onAddressSelected={this.onAddressSelected}
        onParkingSpaceAddressSelected={this.onParkingSpaceAddressSelected}
        onFiscalCodeChange={this.onFiscalCodeChange}
        onSearchFiscalCodeAndFormFilling={this.onSearchFiscalCodeAndFormFilling}
        searchingFiscalCode={this.state.searchingFiscalCode}
        foundFiscalCode={this.state.foundFiscalCode}
        searchingFiscalCodeInitialized={this.state.searchingFiscalCodeInitialized}
        selectedParkSpaces={this.state.selectedParkingSpaces}
        onAddParkingSpace={this.onAddParkingSpace}
        onMultipleParkingSpaceAddressSelected={this.onMultipleParkingSpaceAddressSelected}
        onRemoveParkSpace={this.onRemoveParkSpace}
        onSubmit={this.onSubmit} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserCreateContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeUserCreateContainer.js